$rise_devtools_selector_overlay_files $mol_view
	rpc_port \
	target_info null
	file_path? \
	file_text? \
	file_error? \
	editor_opened? false
	sub <= content /
	Actions $mol_view
		sub <= actions_content /
	Open_view_tree $mol_button_minor
		title \view.tree
		click? <=> file_open_view_tree? null
	Open_view_ts $mol_button_minor
		title \view.ts
		click? <=> file_open_view_ts? null
	Open_view_css_ts $mol_button_minor
		title \view.css.ts
		click? <=> file_open_view_css_ts? null
	Save_file $mol_button_minor
		title \Save
		click? <=> file_save? null
	Editor $mol_textarea
		value? <=> file_text? \
		highlight \tree
	Error $mol_view
		sub /
			<= file_error \
